import React from "react";

const IgnitionButton = ({ iAmReady, iAmReadyHandler }) => {
  return (
    <div className="ignition-btn-wrapper">
      {iAmReady && <div className="ignition-btn-active"></div>}

      <div className="button center">
        <input id="checkbox" type="checkbox" onClick={iAmReadyHandler} />
        <div className="button-center center"></div>
        <div className="btn-text">
          <span title="I AM READY!">I AM READY!</span>
        </div>
      </div>
    </div>
  );
};

export default IgnitionButton;
